
  import { defineComponent } from 'vue';
  import './form-navigation.scss';

  /**
    * Form navigation wrapper
    * Applies neccesary classes used to support Umbraco forms and should be wrapped the submit button
    * 
    * @example
    * <code>import TpxFormNavigation from '@manifesto-tech/tpximpact-design-system/components/molecules/form/form-navigation.vue'</code>
    */
  export default defineComponent({
    name: 'TpxFormNavigation',
  });
